export default __webpack_public_path__ + "static/media/lines.1f814fe9.svg";